import MaskToggle from './MaskToggle';
import { getMode } from '../lib/profiles';
import { Camera, ImagePlus, Eye, EyeOff, ScanEye, Layers, X } from 'lucide-react';

export const quickFilters = (lastId) => ({
  last: lastId ? [`id:${lastId}`] : ['id:-'],
  leaks: ['leak', 'defect'],
  maint: ['warn', 'due'],
  all: [],
});
const same = (a, b) => a.length === b.length && a.every((x) => b.includes(x));

export default function OverlayPanel({ t, visible, onToggle, onPhoto, onGallery, onXray, tileOp, setTileOp, filter, setFilter, lastId, onClose }) {
  const qf = quickFilters(lastId), bd = getMode() === 'building';
  return (
    <div className="ov-panel mask" data-testid="overlay-panel">
      <div className="ov-panel-head mask-keep"><b>{t.btnToggleOv}</b><MaskToggle t={t} id="overlaypanel" /><button className="icon-btn" data-testid="overlay-panel-close" onClick={onClose}><X size={14} /></button></div>
      <div className="ov-panel-row">
        <button className="btn btn-primary btn-sm" data-testid="ov-take-photo-btn" onClick={onPhoto}><Camera size={14} /> {t.ovTakePhoto}</button>
        <button className="btn btn-outline btn-sm" data-testid="ov-gallery-btn" onClick={onGallery}><ImagePlus size={14} /> {t.ovGallery}</button>
        <button className="btn btn-dark btn-sm" data-testid="ov-visible-btn" onClick={onToggle}>{visible ? <EyeOff size={14} /> : <Eye size={14} />} {visible ? t.ovHide : t.ovShow}</button>
      </div>
      <label className="ov-panel-slider">
        <Layers size={14} /> <span>{t.ovMapBg}</span>
        <input type="range" min="0" max="100" value={tileOp} data-testid="map-bg-opacity-slider" onChange={(e) => setTileOp(+e.target.value)} />
        <b data-testid="map-bg-opacity-value">{tileOp}%</b>
      </label>
      {!bd && <>
      <button className="btn btn-red btn-sm ov-xray" data-testid="ov-xray-btn" onClick={onXray}><ScanEye size={14} /> {t.ovXray}</button>
      <small className="ov-panel-sub">{t.qfTitle}</small>
      <div className="ov-panel-row" data-testid="quick-filters">
        {Object.entries(qf).map(([k, v]) => (
          <button key={k} className={`chip seg qf-btn ${same(filter, v) ? 'on' : ''}`} data-testid={`qf-${k}-btn`} onClick={() => setFilter(v)}>
            {k === 'leaks' && <i className="mf-dot" style={{ background: '#dc2626' }} />}{k === 'maint' && <i className="mf-dot" style={{ background: '#eab308' }} />}{t['qf_' + k]}
          </button>
        ))}
      </div>
      </>}
    </div>
  );
}
